import { hiPersistor, hiStore } from "../store/hiStore";
import { primePersistor, primeStore } from "../store/primeStore";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "./index.css";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { WidgetLayout as HiWidgetLayout } from "../Hi/WidgetLayout";
import { WidgetLayout as PrimeWidgetLayout } from "../Prime/WidgetLayout";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { LayoutSidebar } from "../Components/Sidebar";
import { Header } from "../Components/Header";
import { Breadcrumbs } from "../Components/Breadcrumbs";

export const SharedLayout = () => {
  const [loginType, setLoginType] = useState(null);
  const [logoutMessage, setLogoutMessage] = useState("");
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 570;

  const handleLogout = (message) => {
    localStorage.clear();
    if (message) {
      setLogoutMessage(message);
      setTimeout(() => {
        setLogoutMessage("");
      }, 3000);
    } else {
      setLogoutMessage("");
    }
  };

  const location = useLocation();

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    const tokenType = localStorage.getItem("token_type");
    const loginType = localStorage.getItem("login_type");
    if (accessToken && tokenType && loginType) {
      setLoginType(loginType);
    } else {
      navigate("/login");
    }
  }, []);

  const PrimeWidget = () => (
    <Provider store={primeStore}>
      <PersistGate loading={null} persistor={primePersistor}>
        <PrimeWidgetLayout onLogout={handleLogout} {...primeDefaultProps} />
      </PersistGate>
    </Provider>
  );

  const HiWidget = () => (
    <Provider store={hiStore}>
      <PersistGate loading={null} persistor={hiPersistor}>
        <HiWidgetLayout onLogout={handleLogout} {...hiDefaultProps} />
      </PersistGate>
    </Provider>
  );

  return (
    <>
      <Helmet>
        <title>
          Mona{" "}
          {loginType === "hi" ? "Hi" : loginType === "prime" ? "Prime" : ""}
        </title>
      </Helmet>

      <div>
        {logoutMessage && <div className="notification">{logoutMessage}</div>}

        <Header location={location}/>
        <div
          style={{
            height: "100vh",
            display: "grid",
            gridTemplateColumns: "auto 1fr auto",
          }}
        >
          <LayoutSidebar />
          <div
            style={{
              marginTop: "62px",
              height: "calc(100vh - 62px)",
            }}
          >
            {!isMobile && <Breadcrumbs />}
            <Outlet />
          </div>
          <div
            style={{
              marginTop: "62px",
              height: "calc(100vh - 62px)",
              overflow: "hidden",
            }}
          >
            {loginType === "prime" ? (
              <PrimeWidget />
            ) : loginType === "hi" ? (
              <HiWidget />
            ) : (
              <>{/*To do: a specific layout to show prime and hi features*/}</>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const hiDefaultProps = {
  rasaServerUrl:
    process.env.REACT_APP_BASE_URL +
    "/api-chatbot-builder/widget/webhook/" +
    process.env.REACT_APP_CHANNEL_ID_HI,
  loginUrl:
    process.env.REACT_APP_BASE_URL + "/api-chatbot-builder/widget/auth/token",
  userId: "",
  initialPayload: "/start",
  metadata: {},
  widgetColor: "#134780",
  textColor: "#000000",
  userMsgBackgroundColor: "#D9E1EA",
  botTitle: "Hi Mona",
  botSubTitle: "",
  botMsgBackgroundColor: "#f3f4f6",
  botResponseDelay: "",
  chatHeaderCss: {
    textColor: "#ffffff",
    backgroundColor: "#134780",
    enableBotAvatarBorder: true,
  },
  chatHeaderTextColor: "#4c1d95",
  botMsgColor: "#4b5563",
  userMsgColor: "#4c1d95",
  buttonsCss: {
    color: "#4c1d95",
    backgroundColor: "#e1d7ff",
    borderColor: "#4b5563",
    borderWidth: "0px",
    borderRadius: "999px",
    hoverBackgroundColor: "white",
    hoverColor: "#4b5563",
    hoverborderWidth: "1px",
    enableHover: false,
  },
  embedded: false,
};

const primeDefaultProps = {
  rasaServerUrl:
    process.env.REACT_APP_BASE_URL +
    "/api-chatbot-builder/widget/webhook/" +
    process.env.REACT_APP_CHANNEL_ID_PRIME,
  loginUrl:
    process.env.REACT_APP_BASE_URL + "/api-chatbot-builder/widget/auth/token",
  userId: "",
  initialPayload: "/start",
  metadata: {},
  widgetColor: "#134780",
  textColor: "#000000",
  userMsgBackgroundColor: "#D9E1EA",
  botTitle: "Mona",
  botSubTitle: "",
  botMsgBackgroundColor: "#f3f4f6",
  botResponseDelay: "",
  chatHeaderCss: {
    textColor: "#ffffff",
    backgroundColor: "#134780",
    enableBotAvatarBorder: true,
  },
  chatHeaderTextColor: "#4c1d95",
  botMsgColor: "#4b5563",
  userMsgColor: "#4c1d95",
  buttonsCss: {
    color: "#4c1d95",
    backgroundColor: "#e1d7ff",
    borderColor: "#4b5563",
    borderWidth: "0px",
    borderRadius: "999px",
    hoverBackgroundColor: "white",
    hoverColor: "#4b5563",
    hoverborderWidth: "1px",
    enableHover: false,
  },
  embedded: false,
};
